import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Overview.css';
import MachineOverview from '../components/MachineOverview';

import ChangePasswordModal from '../components/ChangePasswordModal';

interface OverviewProps {
    mqttMessage?: string;
}

const Overview: React.FC<OverviewProps> = ({ mqttMessage = "" }) => {
    const navigate = useNavigate();
    const [userEmail, setUserEmail] = useState<string | null>(null);
    const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const email = localStorage.getItem('email');

        if (!token) {
            // Not authenticated, redirect to login
            navigate('/login');
            return;
        }
        setUserEmail(email);
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('email');
        navigate('/');
    };

    return (
        <div className="section" style={{ padding: '20px 0' }}>
            <div className="container">
                <div className="card" style={{ padding: '2rem', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                        <div>
                            <h2>장치 관리</h2>
                            <p>환영합니다, {userEmail}</p>
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <button
                                onClick={() => setIsChangePasswordModalOpen(true)}
                                className="btn btn-outline"
                                style={{ color: '#007bff', borderColor: '#007bff' }}
                            >
                                비밀번호 변경
                            </button>
                            <button onClick={handleLogout} className="btn btn-outline" style={{ color: '#333', borderColor: '#333' }}>로그아웃</button>
                        </div>
                    </div>
                    <MachineOverview mqttMessage={mqttMessage} />
                </div>
            </div>
            {isChangePasswordModalOpen && (
                <ChangePasswordModal onClose={() => setIsChangePasswordModalOpen(false)} />
            )}
        </div>
    );
};

export default Overview;
